import useGetRoleActive from 'hooks/useGetRoleActive';
import React from 'react'

/**
 * Base Input
 * 
 * @param {{
 *  id: string,
 *  placeholder: string,
 *  label: string,
 *  className: string,
 *  access: Array,
 *  isWithLabel: boolean,
 *  isLoading: boolean,
 *  isDisabled: boolean,
 *  props: import('react').InputHTMLAttributes,
 * }} props
 */
const BaseInputTextAreaWithoutGroup = ({ id = 'exampleInputEmail1', className = 'form-control', placeholder = 'Placeholder', label = 'Label', access = [], isWithLabel = true, isDisabled = false, isLoading = false, props }) => {
  const roleActive = useGetRoleActive();

  const isNotAccess = access.length ? !access.includes(roleActive.type) : false

  return (
    <>
      {isWithLabel ?
        <label htmlFor={id}>{label}</label>
        : null}
      <textarea {...props} className={className} disabled={isNotAccess || isDisabled || isLoading} id={id} aria-describedby={`${placeholder}Help`} placeholder={placeholder}></textarea>
    </>
  )
}

export default BaseInputTextAreaWithoutGroup